import http from "./config/NetworkClient";

// Called independently from several places around login/mount (routes/index.js,
// CustomHeader.jsx, SignInForm.jsx, TherapyTab/index.js), firing off duplicate
// requests in the same tick. Coalesce concurrent calls into one in-flight
// request instead of restructuring all those call sites.
let userInstructorsPromise = null;

export default class SettingsApi {
  static async getCardList(payload) {
    const response = await http.get("/client/public/user_card");
    return response;
  }
  static async addNewCard(payload) {
    const response = await http.post("/client/public/user_card", payload);
    return response;
  }
  static async deleteCard(id) {
    const response = await http.put(`/client/public/user_card/${id}/remove`);
    return response;
  }

  static async changeDefaultCard(param) {
    const response = await http.put(
      `/client/public/user_card/${param?.id}/default`,
      {
        default: param?.default,
      }
    );
    return response;
  }

  static async getBillingsList() {
    const response = await http.get("/client/public/user_benefit_provider");
    return response;
  }
  static async addDirectBilling(payload) {
    const response = await http.post(
      "/client/public/user_benefit_provider",
      payload
    );
    return response;
  }
  static async updateDirectBilling(id, payload) {
    const response = await http.put(
      `/client/public/user_benefit_provider/${id}`,
      payload
    );
    return response;
  }
  static async deleteDirectBilling(id) {
    const response = await http.del(
      `/client/public/user_benefit_provider/${id}`
    );
    return response;
  }
  static async detailsDirectBilling(id) {
    const response = await http.get(
      `/client/public/user_benefit_provider/${id}`
    );
    return response;
  }
  static async directBillingProviders() {
    const response = await http.get(
      `/client/public/benefit_provider?sort=id:asc`
    );
    return response;
  }

  static async makeEmailVerificationRequest() {
    const response = await http.post("/client/public/email_verification");
    return response;
  }

  static async verifyEmail(payload) {
    const response = await http.post("/client/public/verify_email", payload);
    return response;
  }
  static async makeChangeEmailRequest(payload) {
    const response = await http.postWithAuth(
      "/authentication/user/change_email",
      payload
    );
    return response;
  }
  static async verifyChangeEmail(payload) {
    const response = await http.postWithAuth(
      "/authentication/user/verify_change_email",
      payload
    );
    return response;
  }
  static async getReduceRateQuestions() {
    const response = await http.get(
      "/client/public/reduced_rate_question?platform_type=ALL"
    );
    return response;
  }
  static async getReduceRateStatus() {
    const response = await http.get("/client/public/user_reduced_rate");
    return response;
  }
  static async submitReduceRateQuestions(payload) {
    const response = await http.post(
      "/client/public/reduced_rate_question?platform_type=ALL",
      payload
    );
    return response;
  }

  //waitlist
  static async getUserWaitlistInfo() {
    const response = await http.get(`/api/v3/pre_waitlist_info`);
    return response;
  }
  static async getWaitlist() {
    const response = await http.get(`/api/v3/waitlist`);
    return response;
  }
  static async archiveWaitlist(id) {
    const response = await http.post(`/api/v3/waitlist/${id}/archive`);
    return response;
  }
  static async addWaitlist(payload) {
    const response = await http.post(`/api/v3/waitlist`, payload);
    return response;
  }
  static async updateWaitlist(id, payload) {
    const response = await http.put(`/api/v3/waitlist/${id}`, payload);
    return response;
  }
  static async getUserInstructors() {
    if (userInstructorsPromise) return userInstructorsPromise;
    userInstructorsPromise = http
      .get(`/client/public/user_instructors`)
      .finally(() => {
        userInstructorsPromise = null;
      });
    return userInstructorsPromise;
  }
  static async getAppointmentTypes(id) {
    const response = await http.get(
      `/api/v3/user_instructors/${id}/appointment_types`
    );
    return response;
  }
  static async getInvoices(page, limit) {
    const response = await http.get(
      `/client/public/invoice?page=${page}&limit=${limit}`
    );
    return response;
  }
}
